import { AxiosInterceptorManager } from "axios";
import { AxiosHookInjector, AxiosInterceptorHook } from "../types";
import { AxiosInterceptor, AxiosHandlerType } from "../../types";
import { toArray } from "../utils";

export function throwError(e: Error) {
  throw e;
}

export function useAxiosInterceptor<T>(
  manager: AxiosInterceptorManager<T>,
  interceptor: AxiosInterceptorHook<T>,
  useUnshift?: boolean
) {
  const { resolve, reject, options } = interceptor;
  const param: AxiosInterceptor<T> = {
    fulfilled: resolve,
    rejected: reject || throwError,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : undefined,
    prio: options ? options.prio : undefined
  };
  if (useUnshift) manager.handlers.unshift(param);
  else manager.handlers.push(param);
}

export const injectAxiosInterceptorHook: AxiosHookInjector = ({
  axios,
  type,
  hook
}) => {
  if (!hook.interceptor) return;
  const items: AxiosInterceptorHook<any>[] = toArray(hook.interceptor[type]);
  items.forEach(item =>
    useAxiosInterceptor(
      axios.interceptors[type],
      item,
      type === AxiosHandlerType.request
    )
  );
};
